import { render, staticRenderFns } from "./OtherOfficeConnectionListTab.vue?vue&type=template&id=724ef464&scoped=true&lang=pug"
import script from "./OtherOfficeConnectionListTab.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeConnectionListTab.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeConnectionListTab.vue?vue&type=style&index=0&id=724ef464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ef464",
  null
  
)

export default component.exports